import React from "react";

type Props = {
  image: string;
  title: string;
  description: string;
};

const BenefitCard: React.FC<Props> = ({ description, image, title }) => {
  return (
    <div className="flex w-full max-w-[400px] flex-col items-start justify-start gap-8 rounded-2xl bg-card-background-light px-8 pb-10 pt-8">
      <img src={image} className="relative h-8 w-8" alt="benefit-icon" />
      <div className="flex flex-col items-start justify-end gap-4">
        <div className="self-stretch text-2xl font-normal leading-[28.80px] text-primary">
          {title}
        </div>
        <div className="self-stretch text-lg leading-[25.20px] text-light text-opacity-80">
          {description}
        </div>
      </div>
    </div>
  );
};

export default BenefitCard;
